import { useEffect } from "react";
import { hasOpenOverlay, hasTransientPopupOpen } from "@/hooks/useOverlayDismiss";
import { matchesCommandPaletteShortcut } from "@/lib/keyboardShortcuts";

type UseCommandPaletteShortcutOptions = {
  onToggle: () => void;
  /** When true, allow toggle even though the palette dialog registers on the overlay stack. */
  paletteOpen?: boolean;
  enabled?: boolean;
};

export default function useCommandPaletteShortcut({
  onToggle,
  paletteOpen = false,
  enabled = true
}: UseCommandPaletteShortcutOptions) {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.repeat) return;
      if (!matchesCommandPaletteShortcut(event)) return;
      if (document.body.dataset.goNavMode === "true") return;
      if (!paletteOpen && (hasOpenOverlay() || hasTransientPopupOpen())) return;

      event.preventDefault();
      onToggle();
    };

    document.addEventListener("keydown", handleKeyDown, true);
    return () => document.removeEventListener("keydown", handleKeyDown, true);
  }, [enabled, onToggle, paletteOpen]);
}
